<template>
  <b-modal
      :id="id"
      :content-class="modalClass"
      :header-class="headerClass"
      :body-class="bodyClass"
      :footer-class="footerClass"
      :no-close-on-backdrop="noCloseOnBackdrop"
      :no-close-on-esc="noCloseOnEsc"
      :size="normalizedSize"
      centered
      @hidden="handleHidden"
  >
    <template #modal-header>
      <div class="ui-modal__title-wrapper" :class="{ 'ui-modal__title-wrapper--separator': headerSeparator }">
        <div class="ui-modal__title">
          <slot name="title">
            <h3>{{ title }}</h3>
          </slot>
        </div>

        <button class="ui-modal__close-btn" @click="hideModal" aria-label="Fechar modal">
          <slot name="close-icon">
            <img src="@src/assets/img/icons/x.svg" alt="ico-close" />
          </slot>
        </button>
      </div>
    </template>

    <!-- Conteúdo principal -->
    <div :class="mainClass">
      <slot name="default" />
    </div>

    <!-- Rodapé com slot -->
    <template #modal-footer>
      <slot name="footer"></slot>
    </template>

  </b-modal>
</template>

<script>
export default {
  name: 'UIModal',
  props: {
    id: {
      type: String,
      required: true
    },
    title: { type: String, default: '' },
    modalClass: { type: String, default: 'ui-modal__content' },
    headerClass: { type: String, default: 'ui-modal__header' },
    bodyClass: { type: String, default: 'ui-modal__body' },
    footerClass: { type: String, default: 'ui-modal__footer' },
    mainClass: { type: String, default: 'ui-modal__main' },

    noCloseOnBackdrop: { type: Boolean, default: false },
    noCloseOnEsc: { type: Boolean, default: false },
    size: { type: String, default: 'md' },

    headerSeparator : { type: Boolean, default: false }
  },
  computed: {
    normalizedSize() {
      const validSizes = ['sm', 'md', 'lg', 'xl'];
      return validSizes.includes(this.size) ? this.size : 'md';
    }
  },
  methods: {
    showModal() {
      this.$bvModal.show(this.id)
    },
    hideModal() {
      this.$bvModal.hide(this.id)
    },
    handleHidden() {
      this.$emit('hide')
    }
  }
}
</script>

<style lang="scss">
@import '@src/design/ui-design/_variables.scss';

.ui-modal__title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  &--separator {
    border-bottom: 1px solid $gray-100-1;
    padding-bottom: 25px;
  }
}

.ui-modal__title {
  flex: 1;
  h3 {
    @include font-properties(
      $font-family-inter,
      24px,
      600,
      normal,
      $gray-500
    );
    margin: 0;
  }
}

.ui-modal__close-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  svg {
    width: 40px;
    height: 40px;
  }
}

.ui-modal__content {
  width: 100%;
  padding: 40px 32px;
  border-radius: 20px;
  background: $gray-white;
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.ui-modal__header {
  border: none;
  padding: 0;
  display: flex;
  min-height: auto;
}

.ui-modal__body {
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ui-modal__main {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  width: 100%;

  &--icon {
    display: flex;
    width: 65px;
    height: 65px;
    padding: 21px 22px;
    justify-content: center;
    align-items: center;
    border-radius: 32.5px;
    background: $gray-10;

    svg {
      stroke-width: 1.8px;
      width: 15px;
      height: 28.636px;
    }
  }

  &--text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
    max-width: 414px;
  }

  &--title {
    @include font-20px-title-modal;
    margin: 0;
  }

  &--description,
  &--info {
    @include font-15-text-modal;
    margin: 0;
  }
}

.ui-modal__footer {
  display: flex;
  gap: 16px;
  width: 100%;
  padding: 0 !important;
  border-top: none !important;
}
</style>
